import React, { useState, useEffect } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { toast } from 'sonner';
import { Loader2, Mail, Check, Clock } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/contact`);
      setContacts(response.data);
    } catch (error) {
      toast.error('Napaka pri nalaganju sporočil');
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      await axios.put(`${API}/contact/${id}/read`);
      toast.success('Označeno kot prebrano');
      fetchContacts();
    } catch (error) {
      toast.error('Napaka');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('sl-SI');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-8 h-8 text-emerald-400 animate-spin" />
      </div>
    );
  }

  const unreadCount = contacts.filter(c => !c.read).length;

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <p className="text-stone-400">
          {contacts.length} sporočil
          {unreadCount > 0 && (
            <span className="ml-2 text-emerald-400">({unreadCount} neprebranih)</span>
          )}
        </p>
      </div>

      {/* Contacts List */}
      <div className="space-y-4">
        {contacts.map((contact) => (
          <Card 
            key={contact.id} 
            className={`border p-4 ${
              contact.read 
                ? 'bg-stone-800/30 border-stone-700' 
                : 'bg-stone-800/50 border-emerald-600/30'
            }`}
          >
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <Badge variant="outline" className={contact.read ? 'border-stone-600 text-stone-500' : 'border-emerald-500 text-emerald-400'}>
                    {contact.read ? (
                      <><Check className="w-3 h-3 mr-1" /> Prebrano</>
                    ) : (
                      <><Clock className="w-3 h-3 mr-1" /> Novo</>
                    )}
                  </Badge>
                  <span className="text-stone-500 text-sm">
                    {formatDate(contact.created_at)}
                  </span>
                </div>
                <h3 className="text-lg font-semibold text-white mb-1">{contact.name}</h3>
                <a href={`mailto:${contact.email}`} className="text-emerald-400 hover:text-emerald-300 text-sm mb-3 block">
                  {contact.email}
                </a>
                <p className="text-stone-300 whitespace-pre-wrap">{contact.message}</p>
              </div>
              {!contact.read && (
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={() => markAsRead(contact.id)} 
                  className="text-emerald-400 hover:text-emerald-300"
                >
                  <Check className="w-4 h-4 mr-1" />
                  Označi
                </Button>
              )}
            </div>
          </Card>
        ))}

        {contacts.length === 0 && (
          <div className="text-center py-12 text-stone-500">
            <Mail className="w-12 h-12 mx-auto mb-4 opacity-50" />
            Ni prejetih sporočil.
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminContacts;
